import { Injectable } from '@angular/core';
import { Http, Response, URLSearchParams, BaseRequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { CoursDisponible } from './cours-disponible.model';

@Injectable()
export class CoursDisponibleService {

    private resourceUrl = 'api/cours-disponible';

    constructor(private http: Http) { }

    create(coursDisponible: CoursDisponible): Observable<CoursDisponible> {
        let copy: CoursDisponible = Object.assign({}, coursDisponible);
        return this.http.post(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    update(coursDisponible: CoursDisponible): Observable<CoursDisponible> {
        let copy: CoursDisponible = Object.assign({}, coursDisponible);
        return this.http.put(this.resourceUrl, copy).map((res: Response) => {
            return res.json();
        });
    }

    find(id: number): Observable<CoursDisponible> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((res: Response) => {
            return res.json();
        });
    }

    findByAnnee(annee: number): Observable<CoursDisponible[]> {
        return this.http.get(`${this.resourceUrl}/annee/${annee}`).map((res: Response) => {
            return res.json();
         });
    }

    findByAnneeEnCours(): Observable<CoursDisponible[]> {
        return this.http.get(`${this.resourceUrl}/annee-en-cours`).map((res: Response) => {
            return res.json();
        });
    }



    query(req?: any): Observable<Response> {
        let params = new URLSearchParams();
        if (req.type) {
            params.set('type', req.type.toUpperCase());
        }
        return this.http.get(this.resourceUrl, { search: params });
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    toLabelValue(coursDisponible: CoursDisponible[]) {
        let liste = [];
        coursDisponible.forEach(cours => liste.push({label: cours.llCours, value: cours.cCours}));
        return liste;
    }

    private createRequestOption(req?: any): BaseRequestOptions {
        let options: BaseRequestOptions = new BaseRequestOptions();
        if (req) {
            let params: URLSearchParams = new URLSearchParams();
            params.set('page', req.page);
            params.set('size', req.size);
            if (req.sort) {
                params.paramsMap.set('sort', req.sort);
            }
            params.set('query', req.query);

            options.search = params;
        }
        return options;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/cours-disponible/cours-disponible.service.ts